var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBxEdit({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.83521 14.1775L9.51271 14.165L17.5394 6.21496C17.8544 5.89996 18.0277 5.48163 18.0277 5.03663C18.0277 4.59163 17.8544 4.17329 17.5394 3.85829L16.2177 2.53663C15.5877 1.90663 14.4885 1.90996 13.8635 2.53413L5.83521 10.4858V14.1775ZM15.0394 3.71496L16.3635 5.03413L15.0327 6.35246L13.711 5.03163L15.0394 3.71496ZM7.50187 11.1808L12.5269 6.20329L13.8485 7.52496L8.82437 12.5008L7.50187 12.505V11.1808Z",
    fill: "#111111"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.16862 17.5H15.8353C16.7545 17.5 17.502 16.7525 17.502 15.8333V8.61L15.8353 10.2767V15.8333H6.80029C6.77862 15.8333 6.75612 15.8417 6.73445 15.8417C6.70695 15.8417 6.67945 15.8342 6.65112 15.8333H4.16862V4.16667H9.87445L11.5411 2.5H4.16862C3.24945 2.5 2.50195 3.2475 2.50195 4.16667V15.8333C2.50195 16.7525 3.24945 17.5 4.16862 17.5Z",
    fill: "#111111"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxEdit);
export default __webpack_public_path__ + "static/media/bx_edit.9292e816138df64f05509eb0aa27ac27.svg";
export { ForwardRef as ReactComponent };